<template>
  <div  style="height: 100%; width: 100%;">
    <div class="flex-grow-1">
      <v-card class="d-flex flex-column flex" style="height: 100%">
        <v-card-title>
          <div :class="{'mb-3': isMobile}">Profile Settings</div>
          <v-spacer></v-spacer>
          <v-btn
            type="primary"
            color="basic"
            depressed
            rounded
            class="mr-2 white--text"
            @click="enableEdit = !enableEdit">
            {{enableEdit ? 'Disable' : 'Enable'}} Editing
          </v-btn>
          <v-btn
            type="primary"
            color="primary"
            depressed
            rounded
            @click="updateProfile"
            :disabled="!enableEdit"
            :class="{'ml-auto': isMobile}">
            Update
            </v-btn>
        </v-card-title>
        <v-divider></v-divider>

        <v-card-text>
          <div class="d-flex flex-column flex-md-row mt-2 justify-content-start" style="height: 100%;">
            <div :class="{'mr-md-4 ': isMediumAndDown}">
              <v-card elevation="0" rounded :class="{'mx-auto': isMobile}">
                <v-img height="180" width="180" :src="image" :class="{'mx-auto': isMobile}"></v-img>
              </v-card>
<!--              <v-btn color="info" :disabled="getUser.profilePicture != null" depressed elevation="0" width="100%" class="mt-4 mb-2" @click.stop="showUploadPicture = !showUploadPicture" v-if="getUser.temporal === undefined">Change</v-btn>-->

              <div v-if="getUser.temporal !== undefined" class="text-center my-4">
                <v-sheet rounded outlined width="180" class="py-4">
                  <div class="basic--text font-weight-bold">
                    Pay school fees to add photo and signature
                  </div>
                </v-sheet>
              </div>

              <div class="mt-6" v-if="getUser.temporal === undefined">
                <v-sheet outlined rounded class="pa-4 text-center" width="180">
                  <div v-if="signatureError" class="d-flex flex-column align-center">
                    <v-icon size="40" color="grey lighten-1">mdi-draw</v-icon>
                    <div class="basic--text text-caption mt-2">No signature uploaded</div>
                  </div>
                  <div v-else>
                    <v-img :src="signature" height="60px" contain @error="signatureError = true"></v-img>
                  </div>
                </v-sheet>
                <v-dialog v-model="showUploadSignature" persistent max-width="480">
                  <v-card>
                    <v-card-title class="text-h5">
                      Upload Signature
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text class="mt-2">
                      <div class="mx-auto text-center my-2">
                        <canvas id="sig" style="padding: 0; display: block" v-show="sig != null" class="mx-auto"></canvas>
                      </div>
                      <v-file-input label="Select image file to upload" dense outlined v-model="sig"
                        accept="image/png"></v-file-input>
                      <div class="text-center error--text" v-if="showSigError">Image size is incorrect</div>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn text color="error" @click="showUploadSignature = false">Cancel</v-btn>
                      <v-btn text color="primary" @click="uploadSignature" :disabled="sig == null"
                        :loading="uploadingSig">Upload</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-btn color="primary" elevation="0" class="mt-4" width="100%"
                  @click="showUploadSignature = true">Update signature</v-btn>
              </div>
            </div>

            <div class="flex-grow-1 ml-md-8" >
              <div class="d-flex flex-column flex-md-row">
                <div class="mr-md-5 flex-grow-1">
                  <div class="basic--text font-weight-bold">Name</div>
                  <v-text-field outlined dense disabled v-model="getUser.name"></v-text-field>
                </div>
                <div class="flex-grow-1">
                  <div class="basic--text font-weight-bold">Phone</div>
                  <v-text-field outlined dense v-model="userDetails.phone" :disabled="!enableEdit"></v-text-field>
                </div>
              </div>

              <div class="d-flex flex-column flex-md-row">
                <div class="mr-md-5 flex-grow-1">
                  <div class="basic--text font-weight-bold">Email</div>
                  <v-text-field outlined dense :disabled="getUser.email != null || !enableEdit" v-model="userDetails.email"></v-text-field>
                </div>
                <div class="flex-grow-1">
                  <div class="basic--text font-weight-bold">Reg. No:</div>
                  <v-text-field outlined dense disabled v-model="getUser.userId"></v-text-field>
                </div>
              </div>

              <div class="d-flex flex-row">
                <v-switch dense label="Edit Password" v-model="passwordEdit"></v-switch>
              </div>
              <v-divider></v-divider>

              <div class="d-flex flex-column flex-md-row mt-4">
                <div :class="{'mr-md-5': true, 'w-50': isMediumAndUp}">
                  <div class="basic--text font-weight-bold">Old Password</div>
                  <v-text-field outlined dense type="password" :disabled="!passwordEdit" v-model="passwordObj.oldPassword"></v-text-field>
                </div>

                <div class="flex-grow-1">
                  <div class="basic--text font-weight-bold">New Password</div>
                    <v-text-field outlined dense type="password" :disabled="!passwordEdit" v-model="passwordObj.newPassword"></v-text-field>
                  </div>
              </div>



              <div class="d-flex flex-column flex-md-row">
                <div class="mr-md-4 flex-grow-1">
                  <div class="basic--text font-weight-bold">Password Confirmation</div>
                  <v-text-field outlined dense type="password" :disabled="!passwordEdit" v-model="passwordObj.confirmPassword"></v-text-field>
                </div>
              </div>
              <div class="error--text" v-show="passwordError">{{ passwordErrorMessage }}</div>

              <active-sessions-card />
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn type="primary" color="primary" depressed rounded class="px-4" :disabled="!passwordEdit" @click="updatePassword">Update</v-btn>
        </v-card-actions>
      </v-card>
    </div>
    <profile-picture-upload :show="showUploadPicture" :user="getUser" v-on:close="showUploadPicture = !showUploadPicture" v-on:uploaded="profilePictureUploaded"></profile-picture-upload>
    <loading-dialog :show="loading"></loading-dialog>
    <message-box :show="messageShow" :message="message" :type="messageType" v-on:close-message="messageShow = !messageShow"></message-box>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import Api from "@/main/api";
import ErrorResolver from "@/shared/ErrorResolver"
import LoadingDialog from "@ui/components/LoadingDialog";
import MessageBox from "@ui/components/MessageBox";
import ProfilePictureUpload from "@/components/ProfilePictureUpload";
import Defaults from "@/shared/Defaults";
import ActiveSessionsCard from "@ui/components/ActiveSessionsCard.vue";

export default {
  name: "ProfileSettingsPage",
  components: {ActiveSessionsCard, ProfilePictureUpload, MessageBox, LoadingDialog},
  data: () => ({
    activePicker: null,
    date: null,
    menu: false,
    passwordEdit: false,
    enableEdit: false,
    userDetails: {},
    enableMfa: false,
    messageType: '',
    message: '',
    messageShow: false,
    loading: false,
    passwordObj: {},
    passwordErrorMessage: '',
    passwordError: false,
    showUploadPicture: false,
    image: '',
    showSigError: false,
    showUploadSignature: false,
    sig: null,
    signature: null,
    uploadingSig: false,
    signatureError: false,
  }),

  watch: {
    menu (val) {
      val && setTimeout(() => (this.activePicker = 'YEAR'))
    },

    getUser: function(newVal){
      // this.userDetails = JSON.parse(JSON.stringify(newVal))
      if(newVal != null){
        this.userDetails.phone = newVal.phone
        this.userDetails.email = newVal.email
        this.hasMfaEnabled = newVal.mfa
        this.image = Defaults.api + '/profile-picture/fetch?user=' + newVal.userId
        this.signature = Defaults.api + '/signature/fetch?user=' + this.getUser.userId;
      }
    },

    sig: function(){
      if(this.sig != null){
        var i = new Image();
        var c = document.getElementById("sig")
        var context = c.getContext('2d')
        i.src = window.URL.createObjectURL(this.sig)
        i.onload = function (){
          context.drawImage(i, 0, 0)
        }
      }
    }

  },
  methods: {
    save (date) {
      this.$refs.menu.save(date)
    },

    updateProfile(){
      this.loading = true
      this.userDetails.userId = this.getUser.userId
      Api.user.update(this.userDetails)
          .then(res => {
            this.$store.commit('setCurrentUser', {user: res.data})
            this.message = "Profile updated"
            this.messageType = 'success'
            this.messageShow = true
            window.location.reload()
          }).catch(err => ErrorResolver.checkErrors(this, err))
          .finally(() => this.loading = false)
    },

    updatePassword(){
      this.passwordError = false

      if(this.passwordObj.newPassword !== this.passwordObj.confirmPassword){
        this.passwordError = true;
        this.passwordErrorMessage = 'Password mismatch'
        return
      }

      this.loading = true
      this.passwordObj.userId = this.getUser.userId
      Api.auth.updatePassword(this.passwordObj)
          .then(res => {
            this.message = res.data
            this.messageType = 'success'
            this.messageShow = true
            this.passwordObj = {} // clear
          }).catch(err => ErrorResolver.checkErrors(this, err))
          .finally(() => this.loading = false)
    },

    uploadSignature(){
      if(this.sig != null && this.getUser != null){
        if (this.sig.size > 50 * 1024) {
          this.message = "Signature file must be less than 50KB"
          this.messageType = 'error'
          this.messageShow = true
          return
        }
        this.uploadingSig = true

        const fData = new FormData();
        fData.append("file", this.sig);

        Api.signature.setSignature(fData)
            .then(() => {
              this.message = "Signature updated"
              this.messageType = 'success'
              this.messageShow = true
              this.showUploadSignature = false
              this.sig = null
              this.signatureError = false
              this.signature = Defaults.api + '/signature/fetch?user=' + this.getUser.userId + '&t=' + Date.now()
            }).catch(err => ErrorResolver.checkErrors(this, err))
            .finally(() => this.uploadingSig = false)
      }
    },

    profilePictureUploaded(){
      this.image = Defaults.api + '/profile-picture/fetch?user=' + this.getUser.userId;
    }
  },

  computed: {
    ...mapGetters(['getCurrentSession', 'getUser']),

    isMobile: function(){
      return this.$vuetify.breakpoint.smAndDown
    },

    isMedium: function(){
      return this.$vuetify.breakpoint.mdOnly
    },

    isMediumAndDown: function(){
      return this.$vuetify.breakpoint.mdAndDown
    },


    isMediumAndUp: function(){
      return this.$vuetify.breakpoint.mdAndUp
    },
  },

  created(){
    // this.userDetails = JSON.parse(JSON.stringify(this.getUser))

    if(this.getUser != null){
      this.userDetails.phone = this.getUser.phone
      this.userDetails.email = this.getUser.email
      this.hasMfaEnabled = this.getUser.mfa
      this.image = Defaults.api + '/profile-picture/fetch?user=' + this.getUser.userId;
      this.signature = Defaults.api + '/signature/fetch?user=' + this.getUser.userId;
    }
  }
}
</script>

<style scoped>
.w-50{
  width: 50%;
}
</style>
